$(document).ready(function () {

  // 监听快速加购事件
  $('quick-shop').on('on:quick-shop:loaded', function () {
    const id = $(this).attr('id');
    // 关联轮播缩略图
    var thumbsSwiper = new Swiper($(`#${id} .quick-shop-swiper .thums-swiper`)[0], {
      spaceBetween: 10,
      slidesPerView: 6,
      watchSlidesVisibility: true, //防止不可点击
    });

    var gallerySwiper = new Swiper($(`#${id} .quick-shop-swiper .mains-swiper`)[0], {
      spaceBetween: 10,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });

    const variantSelector = $(this).find(
      'variant-selects, variant-radios, variant-mixed-inputs',
    )[0];
    variantSelector &&
      variantSelector.addEventListener('on:variant:change', function ({ detail }) {
        const { variant } = detail
        console.log(variant)

      });
  });
});
